var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 21.9999H16V15.9939C16 13.7849 14.209 11.9939 12 11.9939C9.791 11.9939 8 13.7849 8 15.9939V21.9999H3C2.449 21.9999 2 21.5519 2 20.9999V9.50288L12 2.22988L22 9.50288V20.9999C22 21.5519 21.551 21.9999 21 21.9999ZM23.982 8.99388C23.982 8.68588 23.857 8.38088 23.588 8.18588L12.588 0.184876C12.548 0.155876 12.502 0.141876 12.459 0.119876C12.423 0.100876 12.391 0.0798755 12.352 0.0648755C12.123 -0.0221245 11.875 -0.0211245 11.647 0.0648755C11.609 0.0798755 11.578 0.0998755 11.542 0.118876C11.498 0.141876 11.452 0.155876 11.412 0.184876L0.412 8.18488C0.143 8.38088 0.018 8.68488 0.018 8.99388H0V20.9999C0 22.6559 1.344 23.9999 3 23.9999H9C9.55 23.9999 10 23.5499 10 22.9999V21.9999V15.9939C10 14.8909 10.897 13.9939 12 13.9939C13.103 13.9939 14 14.8909 14 15.9939V21.9999V22.9999C14 23.5499 14.45 23.9999 15 23.9999H21C22.656 23.9999 24 22.6559 24 20.9999V8.99388H23.982Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.b39f4625e10f6ba11baaeaddeb4213b1.svg";
export { ForwardRef as ReactComponent };